import * as React from 'react';

import Input from 'components/inputs/input/Input';

import { __t, applyTranslations } from 'utils/language';

import type { TextEntry } from 'types';

import './cca-creator-search.scss';

import type { SyntheticEvent } from 'react';

applyTranslations(require('./cca-creator-search.i18n.json'));

type Props = {
  value: string,
  onChange: (a: string) => void
};

const CCACreatorSearch = (
  {
    value,
    onChange
  }: Props
): JSX.Element => (
  <section className="cca-creator-search">
    <div className="cca-creator-search__label">
      {__t('cca_creator_search.label')}
    </div>
    <Input
      value={value}
      placeholder={__t('cca_creator_search.placeholder')}
      onChange={(event: SyntheticEvent<TextEntry>) => {
        onChange(event.currentTarget.value);
      }}
    />
  </section>
);

export default CCACreatorSearch;
